<script lang="ts" setup>
import { DotLottieVue, type DotLottieVueInstance } from '@lottiefiles/dotlottie-vue'
import animateCoins from './AnimateCoins.json?url'

const emit = defineEmits([
  'complete',
])

const playerRef = $ref<DotLottieVueInstance>()

onMounted(() => {
  if (playerRef) {
    const dotLottie = playerRef?.getDotLottieInstance()
    dotLottie?.addEventListener('complete', () => {
      emit('complete')
    })
  }
})

defineExpose({
  play: () => new Promise<void>((resolve) => {
    const dotLottie = playerRef?.getDotLottieInstance()
    dotLottie?.play()
    resolve()
  }),
  reset: () => {
    const dotLottie = playerRef?.getDotLottieInstance()
    dotLottie?.stop()
  },
})
</script>

<template>
  <div>
    <DotLottieVue
      ref="playerRef"
      style="height: 200px; width: 200px;"
      :autoPlay="false"
      :loop="false"
      :src="animateCoins"
    />

  </div>
</template>
